import React, { useState } from 'react'
import { useEffect } from 'react'
import NumberFormat from 'react-number-format'
import constant from '../../../constant'
import SuccessMessage from "../../common/SuccessMessage";
import ErrorMessage from "../../common/ErrorMessage";
import { useNavigate, useParams } from 'react-router-dom';

function AddSkills(props) {
    const { detail } = props
    const { id } = useParams()
    const Navigate = useNavigate()
    const [error, setError] = useState(false)
    const params = useParams()

    const [skill, setSkill] = useState({
        SKILL: "",
        SKILLS_DETAILS: "",
        SORT_NUMBER: "",
    })



    const handleReset = (e) => {
        setError(false)
        e.preventDefault();
        id && Navigate(constant.component.skilllist.url)
        setSkill(PrevState => ({
            ...PrevState,
            SKILL: "",
            SKILLS_DETAILS: "",
            SORT_NUMBER: ""
        }))
    }

    const handleChange = e => {
        const { name, value } = e.target
        setSkill({
            ...skill,
            [name]: value
        })

    }
    useEffect(() => {
        (id ? document.title = constant.title.EditSkills : document.title = constant.title.AddSkills)
    }, [])

    const onSubmit = (e) => {
        let pn = params.pageno
        e.preventDefault();
        setSkill(PrevState => ({
            ...PrevState,
            SKILL: "",
            SKILLS_DETAILS: "",
            SORT_NUMBER: ""
        }))
        if (skill.SKILL.trim().length == 0 || skill.SORT_NUMBER.toString().trim().length == 0) {
            setError(true)

        }
        else {
            const model = {
                SKILL: skill.SKILL,
                SORT_NUMBER: skill.SORT_NUMBER,
                SKILLS_DETAILS: skill.SKILLS_DETAILS,

            };
            if (detail) {
                model.SKILL_ID = detail.SKILL_ID
            }
            props.onSubmit(model)
            setError(false)
            model.pageno = pn
        }
    }
    useEffect(() => {
        if (detail) {
            setSkill({
                SKILL: detail.SKILL,
                SKILLS_DETAILS: detail.SKILLS_DETAILS,
                SORT_NUMBER: detail.SORT_NUMBER
            })
        }

    }, [])

    return (

        <React.Fragment>
            <div className="main-content">
                <div className="page-content">
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-12">
                                <div className="page-title-box d-sm-flex align-items-center justify-content-between">
                                    <h4 className="mb-sm-0 " style={{ fontSize: '18px' }}>{id ? 'Update Skills' : 'Add Skills'}</h4>

                                    <div className="page-title-right">
                                        <ol className="breadcrumb m-0">
                                            <li className="breadcrumb-item"><a href="javascript: void(0);">Utilities</a></li>
                                            <li className="breadcrumb-item active">{id ? 'Update Skills' : 'Add Skills'}</li>
                                        </ol>
                                    </div>

                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="card">
                                    <div className="card-body">
                                        <h4 className="card-title mb-4">Skills Information</h4>
                                        {
                                            props.showMsg && (props.response.status ?
                                                <SuccessMessage message={props.response.messageCode} />
                                                :
                                                <ErrorMessage message={props.response.error} />)
                                        }
                                        <div id="basic-example">
                                            <section>
                                                <form>
                                                    <div className="row">
                                                        <div className="col-lg-6">
                                                            <div className="mb-3">
                                                                <label for="basicpill-firstname-input">Skills <span style={{ color: "#FF0000" }}>*</span></label>
                                                                <input type="text"
                                                                    className={error && skill.SKILL.trim().length == 0 ? 'form-control is-invalid ' : 'form-control'}
                                                                    id="basicpill-firstname-input"
                                                                    placeholder="Enter Skills"
                                                                    name="SKILL"
                                                                    value={skill.SKILL}
                                                                    onChange={handleChange}
                                                                />
                                                                {error && skill.SKILL.trim().length == 0 ? <span className='text-danger ml-1'> This Field is Required</span> : ''}
                                                            </div>
                                                        </div>

                                                        <div className="col-lg-6">
                                                            <div className="mb-3">
                                                                <label for="basicpill-address-input">Sort Number <span style={{ color: "#FF0000" }}>*</span></label>
                                                                <NumberFormat
                                                                    className={error && skill.SORT_NUMBER.toString().trim().length == 0 ? 'form-control is-invalid ' : 'form-control'}
                                                                    placeholder="Enter Sort Number"
                                                                    id="basicpill-firstname-input"
                                                                    name="SORT_NUMBER"
                                                                    value={skill.SORT_NUMBER}
                                                                    onChange={handleChange}
                                                                    maxLength={10}
                                                                    allowLeadingZeros={false}
                                                                    allowNegative={false}
                                                                    thousandSeparator={false}
                                                                />
                                                                {error && skill.SORT_NUMBER.toString().trim().length == 0 ? <span className='text-danger ml-1'> This Field is Required</span> : ''}
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div className="row">
                                                        <div className="col-lg-12">
                                                            <div className="mb-3">
                                                                <label for="basicpill-address-input">Skills Details</label>
                                                                <textarea id="basicpill-address-input"
                                                                    className="form-control"
                                                                    rows="2"
                                                                    placeholder="Enter Skills Details"
                                                                    name="SKILLS_DETAILS"
                                                                    value={skill.SKILLS_DETAILS}
                                                                    onChange={handleChange}
                                                                ></textarea>
                                                            </div>
                                                        </div>

                                                    </div>
                                                    <div className="row">
                                                        <div className="col-lg-6">
                                                            <div className="mb-3">
                                                                <button type="button" onClick={(e) => onSubmit(e)} className="btn btn-info waves-effect btn-label waves-light"> <i className="bx bx-check-double label-icon"></i>{detail ? 'Save Changes' : 'Create Skills'}</button>
                                                                &nbsp;&nbsp;
                                                                <button type="button" onClick={(e) => handleReset(e)} className="btn btn-danger waves-effect btn-label waves-light"><i className="bx bx-block label-icon "></i> Cancel</button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </form>
                                            </section>
                                        </div>

                                    </div>

                                </div>

                            </div>

                        </div>


                    </div>
                </div>
            </div>

        </React.Fragment>
    )
}
export default AddSkills